import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";

export default function WelcometoUrxprt() {
  const path = "Assets/scss/homepage.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const { setOTSroute } = useRouteBaseStateContext();

  const NavigateToCreate = (path, thetype) => {
    navigate(`/${lan}/${path}`, { state: { theType: thetype ?? "" } });
  };
  return (
    <div className="welcomepage">
      <div className="welcome-first col-lg-6 col-md-11 mx-auto pt-0">
        <h6>
          👋 Welcome to Urxprt, {profile.first_name} {profile.last_name}
        </h6>
        <h1>Grow your freelancing career with Urxprt</h1>
      </div>
      <div className="col-lg-10 col-md-11 mx-auto expert-1">
        <div className="row it-row">
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Find Post & Browse Projects (PBP)</h5>
              <p>
                Browse a variety of projects, filter by needs, and find the right match.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/searchall?type=1`)}
              >
                Find Post & Browse Projects (PBP)
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Bid in Win business Opportunities (WBO)</h5>
              <p>
                Compete in contests by submitting your best solutions and win exciting business opportunities.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/searchall?type=2`)}
              >
                Explore Win business Opportunities (WBO)
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Find Part time Job (PTJ)</h5>
              <p>
                Find trusted part-time opportunities suited for students, freelancers, and professionals seeking flexible work options.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/searchall?type=3`)}
              >
                Find Part time Job (PTJ)
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>One Time Services (OTS)</h5>
              <p>
                Get instant solutions through on-demand, one-time expert services.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/searchpackaged`)}
              >
                Create OTS
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Turn Assets to Income (TAI)</h5>
              <p>
                Generate income by sharing or renting out your valuable assets.
              </p>
              <a
                className="btn"
                onClick={() => {
                  navigate(`/${lan}/searchrentproducts`);
                  setOTSroute("RentalProducts");
                }}
              >
                Let’s get started
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Bid in Buy & Sell with Auction (BSA)</h5>
              <p>
                Place your bids, win deals, and trade seamlessly with auctions.
              </p>
              <a
                className="btn"
                onClick={() => {
                  navigate(`/${lan}/searchauction`);
                  setOTSroute("Auctionitem");
                }}
              >
                Let’s get started
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Buy & Sell with Market (BSM)</h5>
              <p>
                Explore a wide range of items, list your products, and trade instantly.
              </p>
              <a
                className="btn"
                onClick={() => {
                  navigate(`/${lan}/searchbuyproducts`);
                }}
              >
                Explore buy & sell
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Merger and Acquisition (MAS)</h5>
              <p>
                Discover business merger and acquisition opportunities to expand, collaborate, or invest in growing ventures.
              </p>
              <a
                className="btn"
                onClick={() => {
                  navigate(`/${lan}/searchmergersacquisitions`);
                }}
              >
                Let’s get started
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="homepage-second">
        <div className="upgarde-img">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/homepage/home-banner.png`}
            className="banner w-100"
            alt=""
          />
          <div className="banner-content">
            <h2 className="font-42">
              Upgrade membership <span> & start creating one time </span>
              services (OTS)
            </h2>
            <p>
              Transform your skills into on-demand one-time services. Upgrade today and start monetizing your expertise.
            </p>
            <button
              className="btn"
              onClick={() => navigate(`/${lan}/account/upgrademembership`)}
            >
              View Plans
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
      <div className="col-lg-10 col-md-11 mx-auto expert-1 industries">
        <div className="welcome-first col-lg-8 mx-auto ">
          <h1>Get your work done with industries top experts</h1>
        </div>
        <div className="row it-row">
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Post a Part time Job (PTJ)</h5>
              <p>
                Create part-time job posts and find applicants quickly.
              </p>
              <a
                className="btn"
                onClick={() => NavigateToCreate("createpost", 3)}
              >
                Create a post
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Buy one time service (OTS)</h5>
              <p>
                Get instant solutions through on-demand, one-time expert services.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/searchpackaged`)}
              >
                Explore Services
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Hire Experts</h5>
              <p>
                Hire qualified experts to get your tasks and projects done efficiently.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/hireexpertsmainpage`)}
              >
                Find Experts
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      {
        (profile?.role_type == 3 || profile?.role_type == 4) ? <></> :
          <div className="container-fluid user-sec">
            <div className="col-lg-10 mx-auto">
              <div className="row">
                <div className="col-md-6">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/expert.png`}
                    className="w-100"
                    alt=""
                  />
                </div>
                <div className="col-md-6">
                  <h6>Tailored solution for enterprises</h6>
                  <h2 className="font-42">
                    List your company, work and manage projects seamlessly on Urxprt
                  </h2>
                  <ul>
                    <li>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/homepage/star.svg`}
                        alt=""
                      />
                      List your brand on Urxprt
                    </li>
                    <li>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/homepage/star.svg`}
                        alt=""
                      />
                      Hire and manage experts on urxprt
                    </li>
                    <li>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/homepage/star.svg`}
                        alt=""
                      />
                      Task and billing management
                    </li>
                  </ul>
                  <button
                    className="btn"
                    onClick={() => navigate(`/${lan}/account/upgrademembership`)}
                  >
                    Register as company
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
      }
      {/* <div className="col-lg-10 mx-auto bxp-section">
        <div className="bxp-head">
          <h3 className="font-42">Browse One time services (OTS)</h3>
          <button
            className="btn"
            onClick={() => navigate(`/${lan}/account/upgrademembership`)}
          >
            View all
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
              alt=""
            />
          </button>
        </div>
        <div className="row bxp-mobile-row">
          <div className="col-md-3 bxp-img col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-1.png`}
              className="w-100"
              alt=""
            />
            <p>Content writing and SEO</p>
            <h6>$30</h6>
          </div>
          <div className="col-md-3 bxp-img col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-2.png`}
              className="w-100"
              alt=""
            />
            <p>Content writing and SEO</p>
            <h6>$30</h6>
          </div>
          <div className="col-md-3 bxp-img col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-3.png`}
              className="w-100"
              alt=""
            />
            <p>Content writing and SEO</p>
            <h6>$30</h6>
          </div>
          <div className="col-md-3 bxp-img col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-4.png`}
              className="w-100"
              alt=""
            />
            <p>Content writing and SEO</p>
            <h6>$30</h6>
          </div>
        </div>
      </div> */}
    </div>
  );
}
